import { Controller } from '@hotwired/stimulus'
import { keepInsideViewport, placePopover, popoverTrigger } from '@/lib/popover-placement'

export default class extends Controller<HTMLElement> {
  static override values = {
    clamp: { type: Boolean, default: false },
    focus: { type: String, default: '[role^="menuitem"]' },
  }

  declare readonly clampValue: boolean
  declare readonly focusValue: string

  place() {
    const trigger = popoverTrigger(this.element)
    if (trigger) placePopover(this.element, trigger, { clamp: this.clampValue })
  }

  toggled(event: ToggleEvent) {
    const open = event.newState === 'open'
    popoverTrigger(this.element)?.setAttribute('aria-expanded', String(open))
    if (!open) return

    keepInsideViewport(this.element)
    requestAnimationFrame(() => this.element.querySelector<HTMLElement>(this.focusValue)?.focus())
  }
}
